import styled from '@emotion/styled'

import { NativeLink, Text, typography } from 'main/ui'

interface IContainerProps {
  align?: 'left' | 'center'
}

export const Container = styled.div<IContainerProps>`
  text-align: ${props => props.align};
`

export const Title = styled(Text)`
  font-weight: ${typography.fontWeight.bold};
`

export const PhoneLink = styled(NativeLink)`
  white-space: nowrap;
`
